module.exports = __webpack_public_path__ + "static/media/greeting.340779e6.png";